module.exports = __webpack_public_path__ + "img/logo.6839d44f.jpg";